import { BreakdownColumn } from '../../types.js';
import { adjustment } from '../../utils/formatters/adjustment.js';
import { calculations } from '../../utils/formatters/calculations.js';

export const GLA_BREAKDOWN_ALL_MANUFACTRUED_TEXT =
  'The price per square foot of the manufactured home includes the number of sections, the  foundation type, delivery mileage, climate package, fireplaces, kitchen and bathrooms, and all the various building materials, components and features.  Note if the GLA is similar between properties, but a value difference exists, this value difference is attributed to one of the other features of the home such as the number of sections of the home.';

export const GLA_BREAKDOWN_SFR_ONLY_TEXT =
  'The price per square foot of the above grade area includes things like the design of home, heating and cooling systems, kitchen and bathrooms, and all the various building materials, components and features. Note if the GLA is similar between properties, but a value difference exists. This value difference is attributed to either the number of bathrooms or the design of the home (i.e. 1 story vs. 2 story, etc.)';

export const GLA_BREAKDOWN_ALL_MULTIFAMILY_TEXT =
  'The price per square foot of the GBA includes things like the number of units, design of home,  heating and cooling systems, kitchen and bathrooms, and all the various building materials, components and features.  Note if the GBA is similar between properties, but a value difference exists. This value difference is attributed to either the number of bathrooms or the design of the home (i.e. 1 story vs. 2 story, etc.)';

export const GLA_BREAKDOWN_MULTIPLE_TYPES_TEXT =
  'The price per square foot of the above grade area includes the design of home,  heating and cooling systems, kitchen and bathrooms, and all the various building materials, components and features.  For a manufactured home it also includes the number of sections, the  foundation type, delivery mileage, climate package and fireplaces.  For multi-family homes it also includes the number of units.  Note if the GLA is similar between properties, but a value difference exists, this value difference is attributed to one of the other features of the home.';

export const GLA_BREAKDOWN_ALL_MANUFACTURED_COLUMNS: BreakdownColumn[] = [
  { header: 'Square Feet', type: 'feature', path: 'sqft', adjustmentType: 'mainDwelling' },
  { header: 'Bathrooms', type: 'feature', path: 'bathrooms', adjustmentType: 'mainDwelling' },
  { header: 'Sections', type: 'feature', path: 'sections', adjustmentType: 'mainDwelling' },
  { header: 'Fndn', type: 'feature', path: 'foundationType', adjustmentType: 'mainDwelling' },
  {
    header: 'Adjustment Calculation',
    type: 'adjustment',
    path: 'calculations',
    valueFormatter: calculations,
    adjustmentType: 'mainDwelling',
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    path: 'adjustment',
    valueFormatter: adjustment,
    textAlign: 'right',
    adjustmentType: 'mainDwelling',
    includeTooltip: true,
  },
  { header: 'Price / SF', type: 'feature', path: 'costPerSqft', adjustmentType: 'mainDwelling' },
];

export const GLA_BREAKDOWN_SFR_COLUMNS: BreakdownColumn[] = [
  { header: 'Square Feet', type: 'feature', path: 'sqft', adjustmentType: 'mainDwelling' },
  { header: 'Bathrooms', type: 'feature', path: 'bathrooms', adjustmentType: 'mainDwelling' },
  { header: 'Stories', type: 'feature', path: 'stories', adjustmentType: 'mainDwelling' },
  {
    header: 'Adjustment Calculation',
    type: 'adjustment',
    path: 'calculations',
    valueFormatter: calculations,
    adjustmentType: 'mainDwelling',
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    path: 'adjustment',
    valueFormatter: adjustment,
    textAlign: 'right',
    adjustmentType: 'mainDwelling',
    includeTooltip: true,
  },
  { header: 'Price / SF', type: 'feature', path: 'costPerSqft', adjustmentType: 'mainDwelling' },
];

export const GLA_BREAKDOWN_ALL_MULTIFAMILY_COLUMNS: BreakdownColumn[] = [
  { header: 'GBA', type: 'feature', path: 'sqft', adjustmentType: 'mainDwelling' },
  { header: 'Units', type: 'feature', path: 'units', adjustmentType: 'mainDwelling' },
  {
    header: 'Adjustment Calculation',
    type: 'adjustment',
    path: 'calculations',
    valueFormatter: calculations,
    adjustmentType: 'mainDwelling',
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    path: 'adjustment',
    valueFormatter: adjustment,
    textAlign: 'right',
    adjustmentType: 'mainDwelling',
    includeTooltip: true,
  },
  { header: 'Price / SF', type: 'feature', path: 'costPerSqft', adjustmentType: 'mainDwelling' },
];

export const GLA_BREAKDOWN_MULTIPLE_TYPES_COLUMNS: BreakdownColumn[] = [
  { header: 'Square Feet', type: 'feature', path: 'sqft', adjustmentType: 'mainDwelling' },
  { header: 'Bathrooms', type: 'feature', path: 'bathrooms', adjustmentType: 'mainDwelling' },
  {
    header: 'Property Type',
    type: 'feature',
    path: 'propertyType',
    adjustmentType: 'mainDwelling',
  },
  {
    header: 'Adjustment Calculation',
    type: 'adjustment',
    path: 'calculations',
    valueFormatter: calculations,
    adjustmentType: 'mainDwelling',
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    path: 'adjustment',
    valueFormatter: adjustment,
    textAlign: 'right',
    adjustmentType: 'mainDwelling',
    includeTooltip: true,
  },
  { header: 'Price / SF', type: 'feature', path: 'costPerSqft', adjustmentType: 'mainDwelling' },
];
